import axios from 'axios';
import qs from 'qs';
import Vue from 'vue'
import store from '@/store'
// import { Loading ,Message} from 'element-ui';
// import router from './router'
import '@/assets/css/loading.css'
axios.defaults.withCredentials = true;
axios.defaults.timeout = 10000;
// axios.defaults.baseURL='https://www.baidu.com';
axios.defaults.headers = {
    "Content-Type": 'application/x-www-form-urlencoded;charset=UTF-8',
}

// let vm.axiosNumberArr = [];

let time = null;

axios.defaults.number = 0;
// let url= process.env.NODE_ENV === 'production'?'http://csportal.hxmxfj.com/':'';/*设置全局请求地址*/
import matchDomainName from './matchDomainName';
let hostUrl = '';
let productionUrl = matchDomainName.production();
let testUrl = matchDomainName.test();
let reg = /^https/ig;
if (process.env.NODE_ENV === 'production') {
    if (productionUrl.flag) {
        reg.test(productionUrl.hostname) ? (hostUrl = 'https://portal.hxmxfj.com/') : (hostUrl = 'http://portal.hxmxfj.com/')
    }
    if (testUrl.flag) {
        reg.test(testUrl.hostname) ? (hostUrl = 'https://csportal.hxmxfj.com/') : (hostUrl = 'http://csportal.hxmxfj.com/')
    }
} else {
    // hostUrl ='http://192.168.0.150:8080/';
}


axios.interceptors.request.use((config) => {
    // config.isLoading&&(config.isLoading = Loading.service({fullscreen: true}));
    if (config.method === 'post' && config["headers"]["Content-Type"] === 'application/x-www-form-urlencoded;charset=UTF-8') {
        config.data = qs.stringify(config.data);
    }
    let url = config.url.toLocaleLowerCase();
    if(url.includes('report')){
      config.timeout = 20000;//报表时间延长
    }


    // config.url = hostUrl + config.url;/*拼接完整请求路径*/
    // console.log('==config==')
    // console.log(config)


    return config;
}, (error) => {
    new Vue().$loading.close()
    return Promise.reject(error);
});

//登录拦截
axios.interceptors.response.use(function (response) {
    if (response.status != 200) {
        return Promise.reject(response)
    }
    if (parseInt(response.data.scode) == -7) {
        store.commit('updateContentMessage', response.data.smsg);
        store.commit('toggleShowMask', true);
        new Vue().$loading.close();
        return Promise.reject(response);
    }
    if (parseInt(response.data.scode) == 0) {
        store.commit('toggleShowMask', false);
    }
    vm.axiosNumberArr.length >= 1 && vm.axiosNumberArr.pop();
    if (vm.axiosNumberArr.length == 0) {
        try {
          if (!window.vm.timer) {
            new Vue().$loading.close();
          }
        } catch (error) { }
    }
    clearTimeout(time);
    time = setTimeout(() => {
        try {
            if (!window.vm.timer) {
            new Vue().$loading.close();
            }
            vm.axiosNumberArr = [];
        } catch (error) { }
    }, 1000)
    return response
}, function (error) {

    // Message.error({
    //       message: '网络异常，稍后重试！',
    //       type: 'error'
    //   });
    //   error.config.isLoading&&error.config.isLoading.close();
    try {
        new Vue().$loading.close();
    } catch (error) { }

    return Promise.reject(error)
})

class Axios extends axios {

    constructor() {
        super();
    }

    static setIsLoading(flag = false) {
        super.defaults.isLoading = flag;
        vm.axiosNumberArr.push(1);
        if (flag) {
            new Vue().$loading('加载中...');
        }
    }
    static file(url, params = {}, isLoading = false) {
        this.setIsLoading(isLoading)
        return new Promise((resolve, reject) => {
            url = hostUrl + url;
            var xhr = new XMLHttpRequest();
            // xhr.setRequestHeader("Content-Type", "multipart/form-data");
            // xhr.setRequestHeader("content-type", "application/json;charset=UTF-8");

            xhr.open('post', url);
            // xhr.setRequestHeader("Content-Type", "multipart/form-data");
            // xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

            // 监听上传进度
            xhr.upload.onprogress = function (ev) {
                // 事件对象
                // console.log(ev);

            }
            xhr.send(params);
            xhr.onreadystatechange = function () {
                // console.log(xhr)
                if (xhr.readyState == 4 && xhr.status == 200) {
                    // console.log('resolve')
                    new Vue().$loading.close();
                    resolve(JSON.parse(xhr.responseText))


                } else {
                    setTimeout(() => {
                        new Vue().$loading.close();
                    }, 10000)
                    // reject(xhr)
                    // console.log('reject')

                }
            }
        })



    }
    static request(params = {}, isLoading = false) {

        this.setIsLoading(isLoading)
        return super.request(params);
    }
    static delete(url, params = {}, isLoading = false) {
        url = hostUrl + url;
        this.setIsLoading(isLoading)
        return super.delete(url, params);
    }
    static head(url, params = {}, isLoading = false) {
        url = hostUrl + url;
        this.setIsLoading(isLoading)
        return super.head(url, params);
    }
    static post(url, params = {}, isLoading = false) {

        url = hostUrl + url;
        this.setIsLoading(isLoading);
        return super.post(url, params, isLoading);
    }

    static get(url, params = {}, isLoading = false) {

        url = hostUrl + url;
        this.setIsLoading(isLoading);
        return super.get(url, params, isLoading);
    }

    static put(url, params = {}, isLoading = false) {
        url = hostUrl + url;
        this.setIsLoading(isLoading)
        return super.put(url, params);
    }
    static patch(url, params = {}, isLoading = false) {
        url = hostUrl + url;
        this.setIsLoading(isLoading)
        return super.patch(url, params);
    }
}
export default Axios;

// export  default  axios;



// WEBPACK FOOTER //
// ./src/assets/js/axios.js